import { Button, Stack } from 'component-library';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DefaultWidgetNames, WidgetType } from '@/api/rest/resources/types/widget';
import { UpdateOrganizationSummary } from '@/components/CoPilot/components/OrganizationSummary';
import { Icon } from '@/components/widgets/a/Icon/Icon';
import { WidgetSlotRenderer } from '@/components/widgets/WidgetSlotRenderer';
import { useIsStaffUser } from '@/hooks/useIsStaffUser';
import { useActiveWidgetSlotConfiguration } from '@/hooks/useWidgetConfigurationByOrganizationId';
import { SignedInPageLayout } from '@/layout/signed-in-page';

import { useMenuItems } from '../hooks/useMenuItems';
import { CoPilotCards } from './components/CoPilotCards';
import { CopilotConversationsPage } from './CopilotConversations.page';

export const CopilotPage = () => {
  const { t } = useTranslation();
  const menuItems = useMenuItems();
  const isStaff = useIsStaffUser();
  const [edittingSummary, setEdittingSummary] = useState<boolean>(false);

  const widgetSlotsConfiguration = useActiveWidgetSlotConfiguration(
    DefaultWidgetNames.default_template_copilot,
    WidgetType.t_page,
  );

  return (
    <SignedInPageLayout
      items={menuItems}
      navBarProps={{
        title: t('global.copilot.title'),
        children: isStaff && (
          <Button
            variant='outline'
            onClick={() => setEdittingSummary(!edittingSummary)}
            leftAdornment={<Icon icon='ri-align-left' />}
          >
            {t('global.organization.summary.title')}
          </Button>
        ),
      }}
    >
      <Stack spacing={10}>
        <WidgetSlotRenderer nestedWidget={widgetSlotsConfiguration} />
        {isStaff ? <CopilotConversationsPage /> : <CoPilotCards />}
        {isStaff && (
          <UpdateOrganizationSummary open={edittingSummary} onOpenChange={() => setEdittingSummary(!edittingSummary)} />
        )}
      </Stack>
    </SignedInPageLayout>
  );
};
